// import React, { useState, useEffect } from "react";
// import axios from "axios";

// const ProfitLossPage = () => {
//   const [data, setData] = useState({ lines: [], total_revenue: 0, total_expense: 0, net_profit: 0 });

//   useEffect(() => {
//     axios.get("https://subk.education.com.ly/back/api/reports/profit-loss")
//       .then(res => setData(res.data))
//       .catch(err => console.error(err));
//   }, []);

//   return (
//     <div className="container mt-4" dir="rtl">
//       <h2 className="mb-4">قائمة الأرباح والخسائر</h2>
//       <table className="table table-bordered table-striped">
//         <thead className="table-dark">
//           <tr>
//             <th>الحساب</th>
//             <th>النوع</th>
//             <th>إجمالي مدين</th>
//             <th>إجمالي دائن</th>
//           </tr>
//         </thead>
//         <tbody>
//           {data.lines.map((line, idx) => (
//             <tr key={idx}>
//               <td>{line.AccountName}</td>
//               <td>{line.AccountType === "Revenue" ? "إيراد" : "مصروف"}</td>
//               <td>{line.total_debit}</td>
//               <td>{line.total_credit}</td>
//             </tr>
//           ))}
//           <tr className="table-secondary">
//             <td colSpan="2"><strong>الإجمالي</strong></td>
//             <td><strong>{data.total_expense}</strong></td>
//             <td><strong>{data.total_revenue}</strong></td>
//           </tr>
//           <tr className="table-info">
//             <td colSpan="4"><strong>صافي الربح: {data.net_profit}</strong></td>
//           </tr>
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default ProfitLossPage;
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

const ProfitLossPage = () => {
    const navigate = useNavigate(); // Use useNavigate hook for navigation

  ///////////////////////////////////////////////////////////
   const userPermissionsJSON = localStorage.getItem('USER_PERMISSIONS2');
  const userPermissions = JSON.parse(userPermissionsJSON);
   function getActionsForPage(pageName) {
    const pagePermissions = userPermissions.find(permission => permission.resource === pageName);
    console.log('actionsForPage', pagePermissions);
    if (pagePermissions) {
      return pagePermissions.action;
    } else {
      navigate('/dashboard_1');
      return [];
    }
  }

  const pageName = 'ProfitLossPage';
  const actionsForPage = getActionsForPage(pageName);

///////////////////////////////////
  const [data, setData] = useState({ lines: [], total_revenue: 0, total_expense: 0, net_profit: 0 });
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const fetchReport = async () => {
    try {
      const res = await axios.get("https://subk.education.com.ly/back/api/reports/profit-loss", {
        params: {
          start_date: startDate || undefined,
          end_date: endDate || undefined
        }
      });
      setData(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  // Optional: fetch report automatically when dates change
  useEffect(() => {
    if (startDate && endDate) {
      fetchReport();
    }
  }, [startDate, endDate]);

  return (
    <div className="container mt-4" dir="rtl">
      <h2 className="mb-4">قائمة الأرباح والخسائر</h2>

      <div className="row mb-3">
        <div className="col-md-3">
          <input
            type="date"
            className="form-control"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            placeholder="تاريخ البداية"
          />
        </div>
        <div className="col-md-3">
          <input
            type="date"
            className="form-control"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            placeholder="تاريخ النهاية"
          />
        </div>
        <div className="col-md-3">
          <button className="btn btn-primary" onClick={fetchReport}>
            عرض التقرير
          </button>
        </div>
      </div>

      <table className="table table-bordered table-striped">
        <thead className="table-dark">
          <tr>
            <th>الحساب</th>
            <th>النوع</th>
            <th>إجمالي مدين</th>
            <th>إجمالي دائن</th>
          </tr>
        </thead>
        <tbody>
          {data.lines.map((line, idx) => (
            <tr key={idx}>
              <td>{line.AccountName}</td>
              <td>{line.AccountType === "Revenue" ? "إيراد" : "مصروف"}</td>
              <td>{line.total_debit}</td>
              <td>{line.total_credit}</td>
            </tr>
          ))}
          <tr className="table-secondary">
            <td colSpan="2"><strong>الإجمالي</strong></td>
            <td><strong>{data.total_expense}</strong></td>
            <td><strong>{data.total_revenue}</strong></td>
          </tr>
          <tr className="table-info">
            <td colSpan="4"><strong>صافي الربح: {data.net_profit}</strong></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ProfitLossPage;
